// DocumentServices.ts

import { FilterQueryObject } from '../helpers/FilterHelper';
import { HttpClient } from '../helpers/HttpClient';

export const fetchDocumentFilters = async () => {
  return await HttpClient({
    url: `/v1/documents/filters`,
    method: 'get',
  });
};

export const fetchDocuments = async (queryObject: FilterQueryObject) => {
  return await HttpClient({
    url: `/v1/documents/view`,
    method: 'post',
    data: queryObject,
  });
};

export const fetchDocumentPreview = async (id: string) => {
  return await HttpClient({
    url: `/v1/documents/show`,
    method: 'post',
    data: {
      id,
    },
  });
};

export const getActivatedDocuments = async () => {
  return await HttpClient({
    url: `/v1/documents/activated`,
    method: 'get',
  });
};

export const postActivateDocument = async (id: string) => {
  return await HttpClient({
    url: `/v1/documents/activate`,
    method: 'post',
    data: {
      id,
    },
  });
};

export const fetchPendingDocuments = async () => {
  return await HttpClient({
    url: `/v1/documents/pending-documents`,
    method: 'get',
  });
};

// Fetch pending document by ID
export const fetchPendingDocumentById = async (documentId: string) => {
  return await HttpClient({
    url: `/v1/documents/${documentId}/pending-document`,
    method: 'get',
  });
};

// Fetch document by eSignHash without authentication
export const fetchDocumentByAccessHash = async (eSignHash: string) => {
  return await HttpClient({
    url: `/v1/documents/${eSignHash}/access-hash`,
    method: 'get',
    noAuth: true, // Ensure no authentication is used
  });
};

// Sign document
export const signDocument = async (identifier: string) => {
  const url = `/v1/documents/${identifier}/sign`;
  return await HttpClient({
    url: url,
    method: 'post',
    data: {},
  });
};

// Decline document
export const declineDocument = async (identifier: string, reason: string) => {
  const url = `/v1/documents/${identifier}/decline`;
  return await HttpClient({
    url: url,
    method: 'post',
    data: {
      reason,
    },
  });
};
